export const environment = {
  powerbiReportApiBaseUrl: 'https://func-powerbireport-dev-ae.azurewebsites.net/api/embedToken?code=lEkm7GTlNJqF_FR87L5clkZxRobik9XLoJgXUwPEwB30AzFuU8jH8A==',
  msADAuthConfig: {
    clientId: 'e357f735-1dae-403d-8577-f44aacef5a00',
    tenantId: '3aeff392-9dd1-4825-bc4b-dd3843a0d111',
    authority: 'https://login.microsoftonline.com/3aeff392-9dd1-4825-bc4b-dd3843a0d111',
    redirectUri: '/sso-auth',
    postLogoutRedirectUri: '/sso-auth',
  },
  ssoAuth: {
    scopeUrl: 'f77e51a9-2b46-4937-b16a-435105867eff',
    signupPolicy: 'B2C_1_Signup',
    signinSignupPolicy: 'B2C_1_SSP_MFA_SignInSignUp',
    profilePolicy: 'B2C_1A_ProfileEdit_PhoneNumber',
    clientId: 'f77e51a9-2b46-4937-b16a-435105867eff',
    signupAuthority: 'https://f4dch.b2clogin.com/f4dch.onmicrosoft.com/{signupPolicy}',
    authority: 'https://f4dch.b2clogin.com/f4dch.onmicrosoft.com/{signinSignupPolicy}',
    redirectURI: '/sso-auth',
    knownAuthorities: 'f4dch.b2clogin.com',
    editProfileAuthority: 'https://f4dch.b2clogin.com/f4dch.onmicrosoft.com/{profilePolicy}',
  },
};
